export const FormatsData: {[k: string]: SpeciesFormatsData} = {
	bulbasaur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ivysaur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	venusaur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venusaurmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	venusaurgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	charizardmegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	charizardmegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	charizardgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	squirtle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wartortle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	blastoise: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	blastoisemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	blastoisegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	caterpie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	metapod: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	butterfree: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	butterfreegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weedle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kakuna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beedrill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	beedrillmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	pidgey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pidgeotto: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	pidgeot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidgeotmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rattata: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rattataalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	raticate: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	fearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ekans: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	arbok: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachu: {
		tier: "NFE",
	},
	pikachucosplay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachurockstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachubelle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupopstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuphd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachulibre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuoriginal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuhoenn: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachusinnoh: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuunova: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachukalos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachualola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupartner: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachustarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	pikachugmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuworld: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raichu: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichualola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	sandshrew: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sandshrewalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sandslash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sandslashalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nidoranf: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	nidorina: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	nidoqueen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nidoranm: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	nidorino: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	nidoking: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cleffa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	clefairy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	clefable: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	vulpix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	vulpixalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ninetales: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ninetalesalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zubat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	golbat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	crobat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oddish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gloom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	vileplume: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bellossom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	paras: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	parasect: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	dugtrio: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dugtrioalola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	meowthgalar: {
		tier: "LC",
	},
	meowthgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	persian: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	persianalola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	perrserker: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "RU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	growlithe: {
		tier: "LC",
	},
	growlithehisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	arcanine: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	arcaninehisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	poliwag: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	poliwhirl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	poliwrath: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	politoed: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	abra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kadabra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	alakazam: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	alakazammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	machop: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	machoke: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	machamp: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	machampgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bellsprout: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	weepinbell: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	victreebel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tentacool: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	tentacruel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	geodude: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	geodudealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	graveler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	graveleralola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	golem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	golemalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ponyta: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ponytagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rapidash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rapidashgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowpokegalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	slowbro: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	slowbromega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	slowbrogalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	slowking: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	slowkinggalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "UU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "NFE",
	},
	magnezone: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	farfetchd: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	farfetchdgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sirfetchd: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	doduo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dodrio: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	seel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dewgong: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	grimer: {
		tier: "LC",
	},
	grimeralola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	muk: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mukalola: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gastly: {
		tier: "NFE",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gengarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "AG",
	},
	gengargmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	onix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	steelix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	steelixmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	krabby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kingler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kinglergmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	voltorb: {
		tier: "LC",
	},
	voltorbhisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	electrode: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	electrodehisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	exeggcute: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	exeggutor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	exeggutoralola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cubone: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	marowak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	marowakalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	marowakalolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tyrogue: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	hitmonlee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hitmonchan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hitmontop: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lickitung: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lickilicky: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	koffing: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	weezing: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	weezinggalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rhyhorn: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rhydon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	rhyperior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "UU",
	},
	blissey: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	tangela: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	tangrowth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kangaskhan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kangaskhanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	horsea: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	seadra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	kingdra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	goldeen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	seaking: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	staryu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	starmie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mimejr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mrmime: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mrmimegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	mrrime: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	scyther: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	scizor: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	scizormega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	kleavor: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	smoochum: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	jynx: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	elekid: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	electabuzz: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	electivire: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	magby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	magmar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	magmortar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pinsir: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pinsirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	tauros: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	taurospaldeacombat: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taurospaldeablaze: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	taurospaldeaaqua: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	gyaradosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	lapras: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	laprasgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ditto: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	eeveegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vaporeon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	jolteon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flareon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	espeon: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	umbreon: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	leafeon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaceon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sylveon: {
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	porygon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	porygon2: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	porygonz: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	omanyte: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	omastar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kabuto: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kabutops: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aerodactyl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aerodactylmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	munchlax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	snorlax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	snorlaxgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	articuno: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	articunogalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	zapdos: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	zapdosgalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	moltres: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	moltresgalar: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	mewtwo: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	mewtwomegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mewtwomegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mew: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "UU",
	},
	chikorita: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bayleef: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	meganium: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cyndaquil: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	quilava: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	typhlosion: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	typhlosionhisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	totodile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	croconaw: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	feraligatr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sentret: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	furret: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hoothoot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	noctowl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ledyba: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ledian: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spinarak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ariados: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chinchou: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lanturn: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	togepi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	togetic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	togekiss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	natu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	xatu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ampharosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aipom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ambipom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	yanma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	yanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wooper: {
		tier: "LC",
	},
	wooperpaldea: {
		tier: "LC",
	},
	quagsire: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	murkrow: {
		tier: "NFE",
		doublesTier: "DOU",
	},
	honchkrow: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	misdreavus: {
		tier: "NFE",
	},
	mismagius: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	unown: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wynaut: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wobbuffet: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	girafarig: {
		tier: "NFE",
	},
	farigiraf: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dunsparce: {
		tier: "NFE",
	},
	dudunsparce: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	gligar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gliscor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	snubbull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	granbull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	qwilfish: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	qwilfishhisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	overqwil: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	shuckle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	heracross: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	heracrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sneasel: {
		tier: "NFE",
	},
	sneaselhisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	weavile: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	sneasler: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ursaluna: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	slugma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	magcargo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swinub: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	piloswine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	mamoswine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	corsola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	corsolagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cursola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	remoraid: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	octillery: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	delibird: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mantyke: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mantine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skarmory: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	houndoommega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stantler: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wyrdeer: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	smeargle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	miltank: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raikou: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	entei: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	suicune: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	tyranitarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	lugia: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	hooh: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	celebi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	treecko: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grovyle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	sceptile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sceptilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torchic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	combusken: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	blaziken: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	blazikenmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mudkip: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	marshtomp: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	swampert: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swampertmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	poochyena: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mightyena: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	zigzagoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	zigzagoongalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	linoone: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	linoonegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	obstagoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wurmple: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	silcoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beautifly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cascoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	dustox: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lotad: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lombre: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	ludicolo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	seedot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	nuzleaf: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	shiftry: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	taillow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swellow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	gardevoirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	gallade: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	gallademega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NFE",
	},
	slaking: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nincada: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ninjask: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shedinja: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "AG",
	},
	whismur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	loudred: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	exploud: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "RUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	nosepass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	probopass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skitty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	delcatty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sableye: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	sableyemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	mawile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mawilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	aron: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lairon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	aggron: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aggronmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	medichammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	electrike: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	manectric: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	manectricmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	plusle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	minun: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	volbeat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	illumise: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	budew: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	roselia: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	roserade: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carvanha: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sharpedo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sharpedomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wailmer: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wailord: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cameruptmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torkoal: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spinda: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	trapinch: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	vibrava: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	flygon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	altariamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	zangoose: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	seviper: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lunatone: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	solrock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	corphish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	crawdaunt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	baltoy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	claydol: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lileep: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cradily: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	anorith: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	armaldo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	feebas: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	milotic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	castform: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	castformsunny: {
		isNonstandard: "Past",
	},
	castformrainy: {
		isNonstandard: "Past",
	},
	castformsnowy: {
		isNonstandard: "Past",
	},
	kecleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	banettemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duskull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dusclops: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	dusknoir: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tropius: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chingling: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	chimecho: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	absol: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	absolmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaliemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	froslass: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spheal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sealeo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	walrein: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	clamperl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	huntail: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gorebyss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	relicanth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	luvdisc: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	salamencemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	beldum: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	metang: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	metagross: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	metagrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	regirock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	regice: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	registeel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	latias: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	latiasmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	latios: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	latiosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	kyogre: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	kyogreprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	groudon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	groudonprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	rayquaza: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	rayquazamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "AG",
	},
	jirachi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	deoxys: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	deoxysattack: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	deoxysdefense: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	deoxysspeed: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	turtwig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grotle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	torterra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chimchar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	monferno: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	infernape: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	piplup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	prinplup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	empoleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bidoof: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bibarel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cranidos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rampardos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shieldon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bastiodon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	burmy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wormadam: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamsandy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamtrash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mothim: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pachirisu: {
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cherubi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cherrim: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cherrimsunshine: {
		isNonstandard: "Past",
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	buneary: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lopunny: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lopunnymega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	glameow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	purugly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chatot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spiritomb: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	garchompmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "(OU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lucariomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	skorupi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	drapion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	carnivine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	abomasnowmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rotom: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomheat: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	rotomfrost: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomfan: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotommow: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	uxie: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	mesprit: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	azelf: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	dialga: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	dialgaorigin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	palkia: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	palkiaorigin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	heatran: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	regigigas: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	giratina: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	giratinaorigin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	cresselia: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	phione: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	manaphy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	darkrai: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	shaymin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shayminsky: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arceus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	arceusbug: {
		isNonstandard: "Unobtainable",
	},
	arceusdark: {
		isNonstandard: "Unobtainable",
	},
	arceusdragon: {
		isNonstandard: "Unobtainable",
	},
	arceuselectric: {
		isNonstandard: "Unobtainable",
	},
	arceusfairy: {
		isNonstandard: "Unobtainable",
	},
	arceusfighting: {
		isNonstandard: "Unobtainable",
	},
	arceusfire: {
		isNonstandard: "Unobtainable",
	},
	arceusflying: {
		isNonstandard: "Unobtainable",
	},
	arceusghost: {
		isNonstandard: "Unobtainable",
	},
	arceusgrass: {
		isNonstandard: "Unobtainable",
	},
	arceusground: {
		isNonstandard: "Unobtainable",
	},
	arceusice: {
		isNonstandard: "Unobtainable",
	},
	arceuspoison: {
		isNonstandard: "Unobtainable",
	},
	arceuspsychic: {
		isNonstandard: "Unobtainable",
	},
	arceusrock: {
		isNonstandard: "Unobtainable",
	},
	arceussteel: {
		isNonstandard: "Unobtainable",
	},
	arceuswater: {
		isNonstandard: "Unobtainable",
	},
	victini: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	snivy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	servine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	serperior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	tepig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pignite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	emboar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oshawott: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	dewott: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	samurott: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	samurotthisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	patrat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	watchog: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lillipup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	herdier: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	stoutland: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	purrloin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	liepard: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pansage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pansear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	panpour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simipour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	munna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	musharna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidove: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	tranquill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	unfezant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	blitzle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	zebstrika: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	roggenrola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	boldore: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	gigalith: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	woobat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swoobat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drilbur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	excadrill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	audino: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	audinomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	timburr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gurdurr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	conkeldurr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tympole: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	palpitoad: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	seismitoad: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	throh: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sawk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sewaddle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swadloon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	leavanny: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	whirlipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	scolipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cottonee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	whimsicott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lilliganthisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	basculin: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculinbluestriped: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculinwhitestriped: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	basculegion: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	basculegionf: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	darumaka: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	darumakagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	darmanitan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	darmanitanzen: {
		isNonstandard: "Past",
	},
	darmanitangalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	darmanitangalarzen: {
		isNonstandard: "Past",
	},
	maractus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dwebble: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	crustle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	scraggy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	scrafty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sigilyph: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yamask: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	yamaskgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cofagrigus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	runerigus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tirtouga: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	carracosta: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	archen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	archeops: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	trubbish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	garbodor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	garbodorgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zorua: {
		tier: "LC",
	},
	zoruahisui: {
		tier: "LC",
	},
	zoroark: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zoroarkhisui: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	minccino: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cinccino: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gothita: {
		tier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	solosis: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	duosion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	reuniclus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ducklett: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swanna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	vanillite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	vanillish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	vanilluxe: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	emolga: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	karrablast: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	escavalier: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	frillish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	jellicent: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	alomomola: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	joltik: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	galvantula: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ferroseed: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ferrothorn: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	klink: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	klang: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	klinklang: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	elgyem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	beheeyem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	litwick: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lampent: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	chandelure: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cryogonal: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shelmet: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	accelgor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunfisk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunfiskgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mienfoo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mienshao: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	druddigon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	golett: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	golurk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		tier: "UU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	bouffalant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rufflet: {
		tier: "NFE",
	},
	braviary: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	braviaryhisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	vullaby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mandibuzz: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	heatmor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	durant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	cobalion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	terrakion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	virizion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tornadus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	tornadustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	thundurus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	thundurustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	reshiram: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	zekrom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	landorus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	landorustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	kyurem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	kyuremblack: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	kyuremwhite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	keldeo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	keldeoresolute: {
		isNonstandard: "Past",
	},
	meloetta: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	meloettapirouette: {
		isNonstandard: "Unobtainable",
	},
	genesect: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectburn: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectchill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectdouse: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	genesectshock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	chespin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	quilladin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	chesnaught: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	fennekin: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	braixen: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	delphox: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	greninjaash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bunnelby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	diggersby: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vivillonfancy: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vivillonpokeball: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	florges: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pancham: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pangoro: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	furfrou: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	espurr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	meowstic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	meowsticf: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	honedge: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	doublade: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	aegislash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	aegislashblade: {
		isNonstandard: "Past",
	},
	spritzee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	aromatisse: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swirlix: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	slurpuff: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	inkay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	malamar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	binacle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	barbaracle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	helioptile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	heliolisk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tyrunt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	tyrantrum: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	amaura: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	aurorus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hawlucha: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	dedenne: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carbink: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	sliggoohisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	goodra: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goodrahisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	klefki: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	phantump: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	trevenant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pumpkaboo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pumpkaboosmall: {
		isNonstandard: "Past",
	},
	pumpkaboolarge: {
		isNonstandard: "Past",
	},
	pumpkaboosuper: {
		isNonstandard: "Past",
	},
	gourgeist: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gourgeistsmall: {
		isNonstandard: "Past",
	},
	gourgeistlarge: {
		isNonstandard: "Past",
	},
	gourgeistsuper: {
		isNonstandard: "Past",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	avalugghisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	xerneas: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	xerneasneutral: {
		isNonstandard: "Custom", // can't be used in battle
		tier: "Illegal",
	},
	yveltal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	zygarde: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	zygarde10: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	zygardecomplete: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	diancie: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	dianciemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	hoopa: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	hoopaunbound: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	volcanion: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "NFE",
	},
	decidueye: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	decidueyehisui: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	litten: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	torracat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	incineroar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	popplio: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	brionne: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	primarina: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pikipek: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	trumbeak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	toucannon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yungoos: {
		tier: "LC",
	},
	gumshoos: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gumshoostotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	grubbin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	charjabug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	vikavolt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	vikavolttotem: {
		isNonstandard: "Past",
	},
	crabrawler: {
		tier: "LC",
	},
	crabominable: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricorio: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricoriopompom: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricoriopau: {
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oricoriosensu: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cutiefly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ribombee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ribombeetotem: {
		isNonstandard: "Past",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocmidnight: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocdusk: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wishiwashi: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wishiwashischool: {
		isNonstandard: "Past",
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dewpider: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	araquanid: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	araquanidtotem: {
		isNonstandard: "Past",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lurantistotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	morelull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	shiinotic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	salazzletotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stufful: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bewear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	comfey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oranguru: {
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	passimian: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wimpod: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	golisopod: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pyukumuku: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	typenull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	silvally: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallybug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallydark: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallydragon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyelectric: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyfairy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyfighting: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyfire: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyflying: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyghost: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallygrass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyground: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyice: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallypoison: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallypsychic: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallyrock: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallysteel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	silvallywater: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	minior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	miniormeteor: {
		isNonstandard: "Past",
	},
	komala: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	turtonator: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	togedemaru: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	togedemarutotem: {
		isNonstandard: "Past",
	},
	mimikyu: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	mimikyutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mimikyubustedtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bruxish: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drampa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dhelmise: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	jangmoo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	hakamoo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	kommoo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	kommoototem: {
		isNonstandard: "Past",
	},
	tapukoko: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tapulele: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tapubulu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tapufini: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	cosmog: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cosmoem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	solgaleo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	lunala: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	nihilego: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	buzzwole: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	pheromosa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	xurkitree: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	celesteela: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	kartana: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	guzzlord: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	necrozma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	necrozmaduskmane: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	necrozmadawnwings: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	necrozmaultra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	magearna: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	magearnaoriginal: {
		isNonstandard: "Unobtainable",
	},
	marshadow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	poipole: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	naganadel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	stakataka: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	blacephalon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	zeraora: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	meltan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	melmetal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	melmetalgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grookey: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	thwackey: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	rillaboom: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	rillaboomgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scorbunny: {
		tier: "LC",
	},
	raboot: {
		tier: "NFE",
	},
	cinderace: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	cinderacegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sobble: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "LC",
	},
	drizzile: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	inteleon: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	inteleongmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skwovet: {
		tier: "LC",
	},
	greedent: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rookidee: {
		tier: "LC",
	},
	corvisquire: {
		tier: "NFE",
	},
	corviknight: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	corviknightgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blipbug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dottler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	orbeetle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	orbeetlegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nickit: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	thievul: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gossifleur: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	eldegoss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wooloo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dubwool: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chewtle: {
		tier: "LC",
	},
	drednaw: {
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drednawgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yamper: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	boltund: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rolycoly: {
		tier: "LC",
	},
	carkol: {
		tier: "NFE",
	},
	coalossal: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	coalossalgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	applin: {
		tier: "LC",
	},
	flapple: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flapplegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	appletun: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	appletungmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silicobra: {
		tier: "LC",
	},
	sandaconda: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandacondagmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cramorant: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cramorantgulping: {
		isNonstandard: "Past",
	},
	cramorantgorging: {
		isNonstandard: "Past",
	},
	arrokuda: {
		tier: "LC",
	},
	barraskewda: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxel: {
		tier: "LC",
	},
	toxtricity: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitylowkey: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitygmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxtricitylowkeygmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sizzlipede: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	centiskorch: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	centiskorchgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clobbopus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grapploct: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sinistea: {
		tier: "LC",
	},
	polteageist: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	hatenna: {
		tier: "LC",
	},
	hattrem: {
		tier: "NFE",
	},
	hatterene: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	hatterenegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	impidimp: {
		tier: "LC",
	},
	morgrem: {
		tier: "NFE",
	},
	grimmsnarl: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	grimmsnarlgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	milcery: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	alcremie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	alcremiegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	falinks: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pincurchin: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snom: {
		tier: "LC",
	},
	frosmoth: {
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	stonjourner: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eiscue: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	indeedee: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	indeedeef: {
		tier: "PU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	morpeko: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	morpekohangry: {
		isNonstandard: "Past",
	},
	cufant: {
		tier: "LC",
	},
	copperajah: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	copperajahgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dracozolt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	arctozolt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dracovish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arctovish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duraludon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duraludongmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dreepy: {
		tier: "LC",
	},
	drakloak: {
		tier: "NFE",
	},
	dragapult: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	zacian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	zaciancrowned: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	zamazenta: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "UUBL",
	},
	zamazentacrowned: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	eternatus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	eternatuseternamax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kubfu: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "NFE",
	},
	urshifu: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	urshifurapidstrike: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "OU",
	},
	urshifugmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	urshifurapidstrikegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zarude: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	zarudedada: {
		isNonstandard: "Unobtainable",
	},
	regieleki: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	regidrago: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	glastrier: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	spectrier: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	calyrex: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "RU",
	},
	calyrexice: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "Uber",
	},
	calyrexshadow: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
		natDexTier: "AG",
	},
	enamorus: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	enamorustherian: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	sprigatito: {
		tier: "LC",
	},
	floragato: {
		tier: "NFE",
	},
	meowscarada: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	fuecoco: {
		tier: "LC",
	},
	crocalor: {
		tier: "NU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	skeledirge: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	quaxly: {
		tier: "LC",
	},
	quaxwell: {
		tier: "NFE",
	},
	quaquaval: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	lechonk: {
		tier: "LC",
	},
	oinkologne: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oinkolognef: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tarountula: {
		tier: "LC",
	},
	spidops: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nymble: {
		tier: "LC",
	},
	lokix: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rellor: {
		tier: "LC",
	},
	rabsca: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	greavard: {
		tier: "LC",
	},
	houndstone: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	flittle: {
		tier: "NFE",
	},
	espathra: {
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	wiglett: {
		tier: "LC",
	},
	wugtrio: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dondozo: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	veluza: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	finizen: {
		tier: "LC",
	},
	palafin: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	smoliv: {
		tier: "LC",
	},
	dolliv: {
		tier: "NFE",
	},
	arboliva: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	capsakid: {
		tier: "LC",
	},
	scovillain: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tadbulb: {
		tier: "LC",
	},
	bellibolt: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	varoom: {
		tier: "LC",
	},
	revavroom: {
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	orthworm: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	tandemaus: {
		tier: "LC",
	},
	maushold: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	cetoddle: {
		tier: "LC",
	},
	cetitan: {
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	frigibax: {
		tier: "LC",
	},
	arctibax: {
		tier: "NFE",
	},
	baxcalibur: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	tatsugiri: {
		tier: "RU",
		doublesTier: "DUber",
		natDexTier: "RU",
	},
	cyclizar: {
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	pawmi: {
		tier: "LC",
	},
	pawmo: {
		tier: "NFE",
	},
	pawmot: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	wattrel: {
		tier: "LC",
	},
	kilowattrel: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	bombirdier: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	squawkabilly: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flamigo: {
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	klawf: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nacli: {
		tier: "LC",
	},
	naclstack: {
		tier: "RU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	garganacl: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UUBL",
	},
	glimmet: {
		tier: "LC",
	},
	glimmora: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	shroodle: {
		tier: "LC",
	},
	grafaiai: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	fidough: {
		tier: "LC",
	},
	dachsbun: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	maschiff: {
		tier: "LC",
	},
	mabosstiff: {
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bramblin: {
		tier: "LC",
	},
	brambleghast: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	gimmighoul: {
		tier: "LC",
	},
	gimmighoulroaming: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	gholdengo: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	greattusk: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	brutebonnet: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	sandyshocks: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	screamtail: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	fluttermane: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	slitherwing: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	roaringmoon: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	irontreads: {
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	ironmoth: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	ironhands: {
		tier: "UUBL",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	ironjugulis: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	ironthorns: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ironbundle: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	ironvaliant: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	tinglu: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	chienpao: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	wochien: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	chiyu: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	koraidon: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	miraidon: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "AG",
	},
	tinkatink: {
		tier: "LC",
	},
	tinkatuff: {
		tier: "NFE",
	},
	tinkaton: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	charcadet: {
		tier: "LC",
	},
	armarouge: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	ceruledge: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	toedscool: {
		tier: "LC",
	},
	toedscruel: {
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	kingambit: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	clodsire: {
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	annihilape: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "OU",
	},
	walkingwake: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	ironleaves: {
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	missingno: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	syclar: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	syclant: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	revenankh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	embirch: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	flarelm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	pyroak: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	breezi: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	fidgit: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	rebble: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tactite: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	stratagem: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	privatyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	arghonaut: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	nohface: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kitsunoh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	monohm: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	duohm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	cyclohm: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	dorsoil: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	colossoil: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	protowatt: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	krilowatt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	voodoll: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	voodoom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	scratchet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tomohawk: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	necturine: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	necturna: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mollux: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cupra: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	argalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	aurumoth: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	brattler: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	malaconda: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cawdet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	cawmodore: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	volkritter: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	volkraken: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	snugglow: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	plasmanta: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	floatoy: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	caimanoe: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	naviathan: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibelle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibellemega: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pluffle: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kerfluffle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pajantom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mumbao: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	jumbao: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	fawnifer: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	electrelk: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	caribolt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	smogecko: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	smoguana: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	smokomodo: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	swirlpool: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	coribalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	snaelstrom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	justyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	equilibra: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	solotl: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	astrolotl: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	miasmite: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	miasmaw: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	chromera: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomicon: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomiconepilogue: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	saharascal: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	saharaja: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pokestarsmeargle: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarbrycenman: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestartransport: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarhumanoid: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmonster: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf00: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf002: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarspirit: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackdoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarwhitedoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackbelt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiantpropo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufopropu2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
};
